unit OrganisationConfiguration;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WebForm.Core, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, GA.Return.Types;

type
  TOrganisationConfigForm = class(TCoreWebForm)
    WebButton1: TButton;
    WebButton2: TButton;
    WebButton3: TButton;
    MainConfigGroupBox: TGroupBox;
    cboClearDownSubmission: TCheckBox;
    cboNoMatching: TCheckBox;
    cboSaveHMRCPassword: TCheckBox;
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton3Click(Sender: TObject);
  private
    FOrganisationConfig: TOrganisationConfiguration;
    { Private declarations }
    procedure SetOrganisationConfig(AOrganisationConfig: TOrganisationConfiguration);
    procedure SaveConfiguration;
    procedure SetData;
  public
    { Public declarations }
    property OrganisationConfig: TOrganisationConfiguration read FOrganisationConfig write SetOrganisationConfig;
  protected procedure LoadDFMValues; override; end;

var
  OrganisationConfigForm: TOrganisationConfigForm;

implementation

{$R *.dfm}

uses MainDataModule;

{ TOrganisationConfigForm }

procedure TOrganisationConfigForm.SetOrganisationConfig(AOrganisationConfig: TOrganisationConfiguration);
begin
  FOrganisationConfig := AOrganisationConfig;
  SetData;
end;

procedure TOrganisationConfigForm.SetData;
begin
  cboClearDownSubmission.Checked := FOrganisationConfig.ClearDownSubmission;
  cboNoMatching.Checked := FOrganisationConfig.NoMatching;
  cboSaveHMRCPassword.Checked := FOrganisationConfig.SaveHMRCPassword;
end;


procedure TOrganisationConfigForm.WebButton1Click(Sender: TObject);
begin
  SaveConfiguration;
  ModalResult := mrOk;
end;

procedure TOrganisationConfigForm.WebButton2Click(Sender: TObject);
begin
  //ModalResult := mrCancel;
  //Resets data back to what it was before saving
  SetData;
end;

procedure TOrganisationConfigForm.WebButton3Click(Sender: TObject);
begin
  ModalResult := mrOk;
end;

procedure TOrganisationConfigForm.SaveConfiguration;
begin
  FOrganisationConfig.ClearDownSubmission := cboClearDownSubmission.Checked;
  FOrganisationConfig.NoMatching := cboNoMatching.Checked;
  FOrganisationConfig.SaveHMRCPassword := cboSaveHMRCPassword.Checked;
end;


procedure TOrganisationConfigForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebButton1 := TButton.Create('OrganisationConfigSave');
  WebButton2 := TButton.Create('OrganisationConfigCancel');
  WebButton3 := TButton.Create('OrganisationConfigClose');
  MainConfigGroupBox := TGroupBox.Create('MainConfigGroupBox');
  cboClearDownSubmission := TCheckBox.Create('ClearDownSubmission');
  cboNoMatching := TCheckBox.Create('NoMatching');
  cboSaveHMRCPassword := TCheckBox.Create('SaveHMRCPassword');

  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  MainConfigGroupBox.BeforeLoadDFMValues;
  cboClearDownSubmission.BeforeLoadDFMValues;
  cboNoMatching.BeforeLoadDFMValues;
  cboSaveHMRCPassword.BeforeLoadDFMValues;
  try
    WebButton1.SetParentComponent(Self);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 320;
    WebButton1.Top := 424;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.ElementClassName := 'btn btn-secondary';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(Self);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 422;
    WebButton2.Top := 424;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.ChildOrder := 1;
    WebButton2.ElementClassName := 'btn btn-secondary';
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebButton3.SetParentComponent(Self);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 524;
    WebButton3.Top := 424;
    WebButton3.Width := 96;
    WebButton3.Height := 25;
    WebButton3.Caption := 'Close';
    WebButton3.ChildOrder := 2;
    WebButton3.ElementClassName := 'btn btn-secondary';
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton3, Self, 'OnClick', 'WebButton3Click');
    MainConfigGroupBox.SetParentComponent(Self);
    MainConfigGroupBox.Name := 'MainConfigGroupBox';
    MainConfigGroupBox.Left := 8;
    MainConfigGroupBox.Top := 24;
    MainConfigGroupBox.Width := 609;
    MainConfigGroupBox.Height := 385;
    MainConfigGroupBox.HeightStyle := ssAuto;
    MainConfigGroupBox.WidthStyle := ssAuto;
    MainConfigGroupBox.BorderColor := clSilver;
    MainConfigGroupBox.Caption := 'Main Configuration';
    MainConfigGroupBox.ChildOrder := 3;
    MainConfigGroupBox.ElementPosition := epIgnore;
    cboClearDownSubmission.SetParentComponent(MainConfigGroupBox);
    cboClearDownSubmission.Name := 'cboClearDownSubmission';
    cboClearDownSubmission.Left := 24;
    cboClearDownSubmission.Top := 40;
    cboClearDownSubmission.Width := 185;
    cboClearDownSubmission.Height := 22;
    cboClearDownSubmission.Caption := 'Clear Down After Submission';
    cboClearDownSubmission.ElementClassName := 'form-check-input';
    cboClearDownSubmission.ElementPosition := epIgnore;
    cboClearDownSubmission.HeightStyle := ssAuto;
    cboClearDownSubmission.HeightPercent := 100.000000000000000000;
    cboClearDownSubmission.WidthStyle := ssAuto;
    cboClearDownSubmission.WidthPercent := 100.000000000000000000;
    cboNoMatching.SetParentComponent(MainConfigGroupBox);
    cboNoMatching.Name := 'cboNoMatching';
    cboNoMatching.Left := 24;
    cboNoMatching.Top := 68;
    cboNoMatching.Width := 185;
    cboNoMatching.Height := 22;
    cboNoMatching.Caption := 'No Name or Address Matching';
    cboNoMatching.ChildOrder := 1;
    cboNoMatching.ElementPosition := epIgnore;
    cboNoMatching.HeightStyle := ssAuto;
    cboNoMatching.HeightPercent := 100.000000000000000000;
    cboNoMatching.WidthStyle := ssAuto;
    cboNoMatching.WidthPercent := 100.000000000000000000;
    cboSaveHMRCPassword.SetParentComponent(MainConfigGroupBox);
    cboSaveHMRCPassword.Name := 'cboSaveHMRCPassword';
    cboSaveHMRCPassword.Left := 24;
    cboSaveHMRCPassword.Top := 96;
    cboSaveHMRCPassword.Width := 185;
    cboSaveHMRCPassword.Height := 22;
    cboSaveHMRCPassword.Caption := 'Save HMRC Gateway Password';
    cboSaveHMRCPassword.ChildOrder := 1;
    cboSaveHMRCPassword.ElementClassName := 'form-check-input';
    cboSaveHMRCPassword.ElementPosition := epIgnore;
    cboSaveHMRCPassword.HeightStyle := ssAuto;
    cboSaveHMRCPassword.HeightPercent := 100.000000000000000000;
    cboSaveHMRCPassword.WidthStyle := ssAuto;
    cboSaveHMRCPassword.WidthPercent := 100.000000000000000000;
  finally
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    MainConfigGroupBox.AfterLoadDFMValues;
    cboClearDownSubmission.AfterLoadDFMValues;
    cboNoMatching.AfterLoadDFMValues;
    cboSaveHMRCPassword.AfterLoadDFMValues;
  end;
end;

end.
